<template>
<div id="partners">

      <div class="container">
        <div class="row">
        </div>
        <div class="row justify-content-between">
          <div class="col-sm-12 col-md-9 buttons">
            <h2>Nossos Parceiros</h2>
            <a target="_blank" href="http://www.kaleydos.com.br/"><img :src="partner1"/></a>
            <a target="_blank" href="http://www.institutojatobas.org.br/"><img :src="partner2"/></a>
            <!-- <a target="_blank" href="https://www.pontosocial.net/"><img :src="partner3"/></a> -->
            <a target="_blank" href="http://www.spotpromo.com.br/#SpotInclusao"><img :src="partner4"/></a>
          </div>
          <div class="col-sm-12 col-md-3 buttons">
            <h2>Apoio</h2>
            <a class="paypal" target="_blank" href="https://paypal.com"><img :src="partner5"/></a>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
import kaleydos from '../../assets/images/kaleydos_logo.png';
import jatobas from '../../assets/images/jatobas_logo.png';
import dotsocial from '../../assets/images/dotsocial_logo.png';
import spotin from '../../assets/images/spotin.jpg';
import paypal from '../../assets/images/paypal_home.png';

export default {
  data(){
    return {
      partner1: kaleydos,
      partner2: jatobas,
      partner3: dotsocial,
      partner4: spotin,
      partner5: paypal
    }
  }
}
</script>

<style scoped lang="scss">
#partners{
  background-color: #fff;
  padding: 40px;

  @media screen and (max-width: 767px ){
    display: none;
    padding: 0px;
  }

  h2{
    font-size: 33px;
    color: #00AE39;
    width: 100%;
    font-family: RalewayBold;
    text-align: left;
  }

  .buttons{
    text-align: center;
    margin-top: 10px;
  }

  a{
    padding-left: 10px;
    padding-right: 10px;
    float: left;
    padding-top: 10px;
    padding-bottom: 10px;
    display: block;
    height: 150px;

    &.paypal{
      margin-top: 20px;
    }
  }

  img{
    padding-top: 20px;
    width: 150px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/home/PartnersSection.vue